<template>
  <div class="is-flex is-justify-content-space-between">
    <div
      class="is-flex is-justify-content-space-between w-100 swap-tablet-mobile-only"
    >
      <div class="itineraryShareValues">
        <div class="is-h2 mb-2">
          <div class="is-flex">
            <h2 v-if="info.itinerary" class="itinerary_code">
              {{ info.itinerary ? info.itinerary.code : "" }}
            </h2>

            <h2 v-if="info.itinerary" class="itinerary_type">
              {{ itineraryTypeName }}
            </h2>

            <b-tag v-if="fromItineraryVersion" type="is-info">
              Version
              <strong style="color: #fff">{{
                fromItineraryVersion.data.version
              }}</strong>
              restored!
            </b-tag>

            <!-- <b-tooltip type="is-warning" position="is-bottom">
              <b-button class="p-0" style="height: auto;" @click="() => setItineraryHistoryModal(true)">
                <b-tag type="is-warning" class="px-3">
                  <b-icon icon="alert" custom-size="mdi-18px"/>
                  <strong style="top: -.1rem;" class="pb-4 ml-1 is-relative">Unstable version</strong>
                </b-tag>
              </b-button>

              <template v-slot:content>
                <p class="is-block" style="width: 12rem; white-space: wrap;">
                  The current version <strong>{{ info.itinerary.version }}</strong> is unstable. We recommend restoring to a stable version. Click the button to access Quote History.
                </p>
              </template>
            </b-tooltip> -->
          </div>
          <div class="is-flex">
            <strong
              v-if="!isEditingTitle && !loadingSkeleton"
              :class="`${
                historyView.isActive ? '' : 'color-secondary'
              } itineraryTitle`"
              @click="toggleEditTitle"
            >
              {{ info.itinerary ? info.itinerary.title.value : "" }}
            </strong>
            <b-skeleton
              height="30px"
              width="200px"
              :active="loadingSkeleton"
            ></b-skeleton>
            <div
              v-if="isEditingTitle && !loadingSkeleton"
              class="is-inline-flex"
            >
              <BaseInput
                placeholder="Add a title."
                type="text"
                :value="form.title || ''"
                custom-size="thin"
                @input.native="validateTitleInput"
                @keydown.native.enter="
                  stopPropagation($event);
                  saveTitle();
                "
                @keydown.native.esc="
                  stopPropagation($event);
                  closeEditTitle();
                "
              />
              <div class="ml-3 is-flex is-justify-space-between">
                <BaseButton
                  class="mr-2"
                  action="secondary"
                  size="medium"
                  :disabled="loadingSkeleton"
                  @click="toggleEditTitle"
                >
                  <p slot="text">Cancel</p>
                </BaseButton>
                <BaseButton
                  action="tercery"
                  size="medium"
                  :disabled="loadingSkeleton"
                  data-action-type="ITINERARY_TITLE_SAVE"
                  @click="saveTitle"
                >
                  <p slot="text">Save</p>
                </BaseButton>
                >
              </div>
            </div>
            <b-tooltip
              v-if="info.itinerary"
              type="is-light"
              class="service_row__notes"
              multilined
              position="is-bottom"
            >
              <b-button style="border: none" @click="showNoteModal = true">
                <span class="icon is-small">
                  <i class="mdi mdi-text-box-outline mdi-18px"></i>
                </span>
                <span
                  v-if="info.itinerary.internal_notes"
                  style="font-size: 8px; margin-left: -7px"
                >
                  ( {{ info.itinerary.internal_notes.length }} )
                </span>
              </b-button>
              <template v-slot:content>
                <p
                  v-if="
                    info.itinerary.internal_notes &&
                    info.itinerary.internal_notes.length > 0
                  "
                  class="service_row_notes__placeholder"
                  v-html="
                    info.itinerary.internal_notes
                      .map((n) => n.content)
                      .join('<br><br>')
                  "
                ></p>
                <p v-else style="width: 8rem">There are no internal notes.</p>
              </template>
            </b-tooltip>
            <MainItineraryActions
              v-if="info.itinerary"
              :loading="loading"
              :itinerary="itinerary"
              :update-service="updateService"
              :switch-tag-modal="switchTagModal"
              :load-prices-itinerary="loadPricesItinerary"
            />
          </div>
        </div>
        <div
          v-if="!loadingSkeleton && itinerary.data"
          class="is-flex is-justify-space-between is-align-items-center"
          style="flex-wrap: wrap; row-gap: 0.5rem"
        >
          <div class="is-flex is-align-items-center mr-4">
            <IconPax class="mtn-3 color-7 mr-1" />
            <span>{{ numPax ? numPax : "" }}</span>
          </div>
          <div class="is-flex is-align-items-center mr-4">
            <span
              :data-test-id="constants.DATA_TEST_ID_VALUES.ITINERARY_NUM_DAYS"
            >
              {{ numDays }}
            </span>
            <span class="ml-1">Day(s)</span>
          </div>
          <div
            class="is-flex is-align-items-center mr-4"
            style="width: 100%; width: 10rem; height: 2rem"
          >
            <b-tooltip
              :active="authConfig.statusChangeEnabled"
              multilined
              class="tooltipSales"
            >
              <template v-slot:content>
                <PhasesProgress
                  :reduced-view="true"
                  :steps="
                    helpers.getQuoteStatusPhases(
                      quoteStatus,
                      orderedQuoteStatuses
                    )
                  "
                />
              </template>

              <div class="is-flex is-align-items-center mr-4 status__select">
                <span class="has-text-weight-semibold mr-1">Status:</span>
                <span v-if="historyView.isActive">{{
                  info.itinerary.status.name
                }}</span>
                <b-select
                  v-else
                  placeholder="Select a status"
                  :value="info.status"
                  :disabled="!displayItineraryStatusSelect"
                  :data-feature="featureName.ITINERARY_STATUS"
                  :lock="!displayItineraryStatusSelect"
                  data-action-type="ITINERARY_STATUS_CHANGE"
                  @input="($event) => onChangeStatus($event)"
                >
                  <option
                    v-for="option in orderedQuoteStatuses"
                    :key="option.id"
                    :value="option.id"
                    :disabled="!option.available"
                  >
                    {{ option.name }}
                    <span v-if="!option.available">🚫</span>
                  </option>
                </b-select>
              </div>
            </b-tooltip>

            <ChangeStatusAndExportWeblink
              v-if="isItineraryPublishedModal"
              :set-loading="setLoading"
              :status-to-change="{
                id: info.status,
                label: getQuoteStatusById(info.status),
              }"
              :on-cancel="onCancelStatusChange"
              :on-continue="changeStatusAndExportWeblink"
              :is-open="isItineraryPublishedModal"
              :show-export-weblink="showExportWeblink"
              @update:is-open="isItineraryPublishedModal = $event"
            />

            <ExternalExportModal
              :is-modal-open="showExternalExportModal"
              :loading="loadingSkeleton"
              :on-external-export-continue="onExternalExportContinue"
              :close-modal="closeChangeStatusModal"
            />
          </div>
          <div class="mx-4">
            <span class="has-text-weight-semibold">By:</span>
            {{ info.itinerary ? info.itinerary.owner.name : "" }}
          </div>
          <TimeResponseAlert
            v-if="!info.meta.deadline.first_status_sent"
            :created="info.itinerary.created_date"
            :meta-deadline="info.meta.deadline"
          />
        </div>
        <b-skeleton
          height="20px"
          width="400px"
          :active="loadingSkeleton"
        ></b-skeleton>
      </div>
      <!--Modal Level Buttons-->
      <div class="is-flex itineraryLevelValues">
        <MainItineraryContentModalLevel
          :itinerary="info.itinerary"
          :load-prices-itinerary="loadPricesItinerary"
          :load-itinerary-passengers="loadItineraryPassengers"
        />
        <!--Modal Level Buttons-->
        <!-- SideBar Country Info -->
      </div>
      <!-- Finish SideBar Country Info -->
    </div>
    <a v-if="showServiceSwitch" href="#">
      <div class="card cardItineraryContent cardShareEmail">
        <div class="card-content has-text-centered">
          <div class="content">
            <b-field class="switchhAllServices">
              <b-switch
                v-model="isSwitchedAllServicesText"
                true-value="Hide Services"
                false-value="Display Services"
                class="is-big color-2 mr-0"
              >
                <p class="mt-2 color-7">{{ isSwitchedAllServicesText }}</p>
              </b-switch>
            </b-field>
          </div>
        </div>
      </div>
    </a>
    <EntityTagModal
      v-if="itinerary.data"
      :is-modal-open="isTagModalOpen"
      :type="tagType"
      data-action-type="ITINERARY_TAG_SAVE"
      :save-tags="saveTags"
      :entity-tags="itinerary.data.tags"
      :close-modal="switchTagModal"
    />
    <NoteModal
      v-if="itinerary.data"
      :is-modal-open="showNoteModal"
      :close-modal="() => (showNoteModal = false)"
      data-action-type="ITINERARY_NOTES_SAVE"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import clonedeep from "lodash.clonedeep";
import { PATH_INFO } from "@/router/path";
import {
  calculateDays,
  deleteObjectProperties,
  openToast,
} from "@/utils/utils";
import MainItineraryActions from "@/components/_shared/MainItineraryActions.vue";
import MainItineraryContentModalLevel from "@/components/_shared/MainItineraryContentModalLevel.vue";
import {
  ITINERARY_STATUS_TO_PUBLISH_QUOTE,
  ITINERARY_STATUS,
  ITINERARY_STATUS_BY_ID,
  REQUEST_STAGES,
  QUOTES_STATUS,
} from "@/constants/itinerary";
import helpers from "@/helpers";
import { helper } from "@/utils/itinerary";
import { DATA_TEST_ID_VALUES } from "@/constants/test";
import PhasesProgress from "./PhasesProgress.vue";
import ExternalExportModal from "@/components/quote-views/_shared/ExternalExportModal.vue";
import ChangeStatusAndExportWeblink from "@/components/quote-views/_shared/ChangeStatusAndExportWeblink.vue";
import EntityTagModal from "@/components/_shared/EntityTagModal.vue";
import { FEATURE_NAME, TAG_TYPES, USER_ROLE } from "@/constants";
import { getLocalStorageData } from "@/utils/localStorage";
import { serviceHelper } from "@//utils/service";
import NoteModal from "@/components/_shared/NoteModal.vue";
import TimeResponseAlert from "@/components/_shared/TimeResponseAlert.vue";

export default {
  name: "MainItineraryContent",
  components: {
    TimeResponseAlert,
    NoteModal,
    EntityTagModal,
    MainItineraryActions,
    MainItineraryContentModalLevel,
    PhasesProgress,
    ExternalExportModal,
    ChangeStatusAndExportWeblink,
  },
  props: {
    showServiceSwitch: {
      type: Boolean,
      default: false,
    },
    loadPrices: {
      type: Boolean,
      default: false,
    },
    updateService: {
      type: Function,
      default: () => {},
    },
    loadServicesItinerary: {
      type: Function,
      default: () => {},
    },
    publishItinerary: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      featureName: FEATURE_NAME,
      isSwitchedAllServicesText: "Display Services",
      isEditingTitle: false,
      form: {
        title: "",
      },
      openModal: null,
      showExternalExportModal: false,
      showCongratulationsMessage: false,
      changeStatusAlertMessage: "",
      isItineraryPublishedModal: false,
      loadingSkeleton: false,
      constants: {
        ITINERARY_STATUS,
        DATA_TEST_ID_VALUES,
      },
      helpers: {
        calculateDays,
        ...helper,
      },
      isTagModalOpen: false,
      tagType: TAG_TYPES.ITY,
      showNoteModal: false,
    };
  },
  computed: {
    ...mapGetters({
      authData: "auth/getAuthData",
      authConfig: "auth/authConfig",
      clients: "client/getClients",
      itinerary: "itinerary/getItinerary",
      quoteStatus: "itinerary/getItineraryStatus",
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      multipleSelectionEnabled: "utils/getMultipleSelectionEnabled",
      published_images_config: "itinerary/getPublishedConfigAndImages",
      loading: "utils/getLoading",
      numPax: "itinerary/getNumPax",
      status_itinerary: "status_itinerary/getQuoteStatuses",
      historyView: "utils/getHistoryView",
      request: "request/getRequest",
      clientContracts: "client/getClientContracts",
      hasAccountOnOtherSystem: "itinerary/getHasAccountOnOtherSystem",
    }),
    showExportWeblink() {
      return this.getShowExportWeblink(this.info.status);
    },
    info() {
      return {
        itinerary: this.itinerary.data,
        status: this.itinerary.data?.status?.id || 1,
        meta: this.itinerary.meta,
      };
    },
    numDays() {
      return (
        calculateDays(
          this.itinerary.data?.start_date,
          this.itinerary.data?.end_date
        ) || 0
      );
    },
    itineraryTypeName() {
      const itineraryTypes = helper.getItineraryTypesMapped();
      return itineraryTypes.find(
        (itineraryType) =>
          itineraryType.id === this.itinerary.data.itinerary_type_id
      )?.name;
    },
    displayItineraryStatusSelect() {
      const disableQuoteByStatus = helper.hasStatus(this.quoteStatus, [
        QUOTES_STATUS.CONFIRMED.id,
      ]);

      return (
        !disableQuoteByStatus &&
        !this.hideElementByCondition &&
        !this.multipleSelectionEnabled
      );
    },
    orderedQuoteStatuses() {
      return JSON.parse(JSON.stringify(this.status_itinerary)).sort((a, b) => {
        return a.order - b.order;
      });
    },
    displayExternalExport() {
      return helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.ADMIN, USER_ROLE.SUPPORT],
        true
      );
    },
    fromItineraryVersion() {
      return getLocalStorageData(
        `from_itinerary_version_${this.$route.query.itinerary}`
      );
    },
  },
  watch: {
    isItineraryPublishedModal(newValue) {
      if (!newValue) {
        this.info.status = this.quoteStatus;
      }
    },
  },
  methods: {
    getShowExportWeblink(status) {
      return ITINERARY_STATUS_TO_PUBLISH_QUOTE.includes(status);
    },
    async onCancelStatusChange() {
      if (this.showExportWeblink) {
        await this.onlyChangeStatus();
      } else {
        this.isItineraryPublishedModal = false;
      }
    },
    async onlyChangeStatus() {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          this.setLoading(true);
          this.openModal = false;
          this.isItineraryPublishedModal = false;

          await this.handleChangeStatus(this.info.status, {
            cur_step: 1,
            last_step: 1,
          });

          this.setLoading(false);
        },
        functionToExecuteOnFail: async (error) => {
          this.setLoading(false);
          throw error;
        },
      });
    },
    getQuoteStatusById(statusId) {
      return this.status_itinerary.find((status) => status.id === statusId)
        ?.name;
    },
    async changeStatusAndExportWeblink() {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          this.setLoading(true);

          this.openModal = false;

          this.isItineraryPublishedModal = false;

          await this.handleChangeStatus(this.info.status, {
            cur_step: 1,
            last_step: 1,
          });

          this.setLoading(false);
        },
        functionToExecuteOnFail: async (error) => {
          this.setLoading(false);
          throw error;
        },
      });
    },
    setItineraryHistoryModal(newValue = false) {
      this.$store.dispatch("utils/setHistoryView", {
        historyView: {
          isModalOpen: newValue,
        },
      });
      if (newValue) this.getItineraryHistory();
    },
    async getItineraryHistory(payload = null) {
      this.setLoading(true);
      await this.$store.dispatch("itinerary/getItineraryHistory", payload);
      this.setLoading(false);
    },
    closeChangeStatusModal() {
      this.openModal = false;
      this.showExternalExportModal = false;
      this.isItineraryPublishedModal = false;
      this.info.status = this.quoteStatus;
    },
    validateTitleInput(event) {
      this.form.title = event.target.value.replace("|", "");
      event.target.value = this.form.title;
    },
    switchTagModal() {
      this.isTagModalOpen = !this.isTagModalOpen;
    },
    onChangeStatus(newStatus) {
      if (
        [QUOTES_STATUS.SENT.id, QUOTES_STATUS.PUBLISHED.id].includes(newStatus)
      ) {
        this.info.status = newStatus;
        this.changeStatusAndExportWeblink();
        return;
      }

      if (newStatus === this.info.status) return;
      this.changeStatusAlertMessage =
        ITINERARY_STATUS_BY_ID?.[newStatus]?.alertText;

      this.isItineraryPublishedModal = true;

      this.info.status = newStatus;
    },
    redirectToExportSection() {
      this.$router.push({
        path: PATH_INFO.EXPORT.path,
        query: { itinerary: this.$route.query.itinerary },
      });
    },
    stopPropagation(event = null) {
      event?.stopPropagation();
    },
    setLoading(value = false) {
      this.$store.dispatch("utils/setLoading", value);
      if (!value) {
        this.setLoadingText("Loading content, please wait...");
      }
    },
    setLoadingText(value) {
      this.$store.dispatch("utils/setLoadingText", value);
    },
    closeEditTitle() {
      this.form.title = "";
      this.isEditingTitle = false;
    },
    async loadPricesItinerary({ reload = false }) {
      if (this.$route.query.itinerary) {
        await this.$store
          .dispatch("itinerary/list_prices", {
            uuid: this.$route.query.itinerary,
            reload,
          })
          .catch((error) => {
            throw error;
          });
      }
    },
    async loadItineraryPassengers(reload = false) {
      if (this.$route.query.itinerary) {
        await this.$store
          .dispatch("itinerary/list_passengers", {
            uuid: this.$route.query.itinerary,
            reload,
          })
          .catch((error) => {
            throw error;
          });
      }
    },
    toggleEditTitle() {
      if (this.disableQuoteByStatus) return;
      if (this.hideElementByCondition) return;

      this.isEditingTitle = !this.isEditingTitle;
      this.loadDay();
    },
    loadDay() {
      this.form.title = this.info.itinerary.title.value;
    },
    async saveTags(payload) {
      try {
        await this.saveData({
          tags: payload.tagIds || [],
          cur_step: payload.cur_step || 1,
          last_step: payload.last_step || 1,
        });
        openToast(this.$buefy, "Tags saved successfully!", "is-success");
      } catch (error) {
        throw error;
      }
    },
    async saveTitle() {
      this.loadingSkeleton = true;
      this.setLoading(true);

      try {
        const language_code = this.itinerary.data.language.language_code;
        const newTitle = this.itinerary.data.title;
        helpers.applyTranslation(language_code, newTitle, this.form.title);
        await this.saveData({
          title: newTitle,
        });
      } catch (error) {
        throw error;
      }

      this.setLoading(false);
      this.toggleEditTitle();

      this.loadingSkeleton = false;
    },
    async saveData(updateData = {}) {
      let itinerary = {
        ...clonedeep(this.itinerary.data),
        ...updateData,
      };

      itinerary.client_id = itinerary.client.id;
      itinerary.currency_id = itinerary.currency.id;
      itinerary.language_id = itinerary.language.id;
      itinerary.status = itinerary.status.id;
      itinerary.num_day = this.numDays;

      deleteObjectProperties(itinerary, ["client", "currency", "language"]);

      await this.$store.dispatch("itinerary/update", itinerary);
    },
    async validateItineraryIsPublished(
      newStatus,
      forceSaving = false,
      externalSource = ""
    ) {
      const params = { source: externalSource };

      const isQuoteChangedToPublished =
        ITINERARY_STATUS_TO_PUBLISH_QUOTE.includes(newStatus);

      if (!forceSaving && isQuoteChangedToPublished) {
        this.openModal = false;
        this.isItineraryPublishedModal = true;
      } else {
        this.loadingSkeleton = true;
        this.setLoading(true);
        if (forceSaving) await this.changeStatus(newStatus, params);
        else await this.handleChangeStatus(newStatus, params);
        const payload = {
          id: this.$route.query.itinerary,
          reload: true,
          from: this.itinerary.data.start_date,
          to: this.itinerary.data.end_date,
        };
        await this.loadServicesItinerary(payload);
        this.loadingSkeleton = false;
        this.setLoading(false);
      }
    },
    async onExternalExportContinue(externalSource = "") {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          this.closeChangeStatusModal();

          await this.$store.dispatch("itinerary/setIsRecentlyExported", true);

          await this.validateItineraryIsPublished(
            ITINERARY_STATUS.CONFIRM.value,
            true,
            externalSource
          );

          await this.$store.dispatch("itinerary/setIsRecentlyExported", false);

          this.showCongratulationsMessage = true;
        },
        functionToExecuteOnFail: async (error) => {
          this.setLoading(false);
          this.loadingSkeleton = false;

          this.$store.dispatch("itinerary/setQuoteExportFailedAlert", {
            isOpen: true,
            title: error?.response?.data?.message,
            items: serviceHelper.adaptServiceExportErrors(
              error?.response?.data?.errors,
              this.$route.query.itinerary
            ),
          });

          throw error;
        },
      });
    },
    async handleChangeStatus(newStatus, params = {}) {
      if (
        newStatus === ITINERARY_STATUS.CONFIRM.value &&
        this.hasAccountOnOtherSystem
      ) {
        this.openModal = false;
        this.isItineraryPublishedModal = false;
        this.showExternalExportModal = true;
        return;
      }
      await this.changeStatus(newStatus, params);
    },
    async changeStatus(newStatus, params = {}) {
      this.setLoading(true);
      this.openModal = false;
      this.isItineraryPublishedModal = false;

      const payload = {
        id: this.$route.query.itinerary,
        status: newStatus,
        ...params,
      };

      await this.updateQuoteStatus(payload);

      this.setLoading(false);
    },
    async updateQuoteStatus(payload) {
      await this.$store
        .dispatch("itinerary/change_status", payload)
        .then((response) => {
          this.$buefy.toast.open({
            duration: 5000,
            message: response.message,
            position: "is-top",
            type: "is-success",
          });
        })
        .catch((error) => {
          this.$buefy.toast.open({
            duration: 5000,
            message:
              "Error trying to change status of itinerary, please try again.",
            position: "is-top",
            type: "is-danger",
          });
          throw error;
        });
    },
    async updateRestRequestQuotesStatus(updatedRestQuotesStatus) {
      if ([null, undefined].includes(updatedRestQuotesStatus)) return;

      const restRequestQuotes = this.request.items.filter(
        (item) => item.id !== this.itinerary.data.id
      );

      if (!restRequestQuotes?.length) return;

      const changeStatusPayloads = restRequestQuotes.map((restRequestQuote) => {
        return {
          id: restRequestQuote.id,
          status: updatedRestQuotesStatus.id,
        };
      });

      await Promise.allSettled(
        changeStatusPayloads.map(
          async (payload) =>
            await this.$store.dispatch("itinerary/changeQuoteStatus", payload)
        )
      );
    },
    async updateRequestStage(quoteStatus) {
      if (!this.request.id) return;

      const response = this.getUpdatedRequesStageAndQuoteStatus(quoteStatus);

      const updatedRequestStage = response.stage;

      const updatedRestQuotesStatus = response.restQuotesStatus;

      this.updateRestRequestQuotesStatus(updatedRestQuotesStatus);

      const isDifferentStage = updatedRequestStage.id !== this.request.stage.id;

      if (!isDifferentStage) {
        return this.$store.dispatch("request/updateRequestItemById", {
          ...this.itinerary.data,
          status: Object.values(QUOTES_STATUS).find(
            (status) => status.id === quoteStatus
          ),
        });
      }

      this.setLoading(true);

      const adaptedRequest = {
        ...this.request,
        client_id: this.request.client.id,
        contract_id: this.clientContracts?.find(
          (clientContract) => clientContract.id === this.request.contract.id
        )?.contract_id,
        stage_id: updatedRequestStage.id,
      };

      await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          return await this.$store.dispatch("request/saveRequest", {
            request: adaptedRequest,
          });
        },
        functionToExecuteOnFail: async (error) => {
          this.setLoading(false);
          this.$buefy.toast.open({
            duration: 5000,
            message: "Error trying to update Request stage, please try again.",
            position: "is-top",
            type: "is-danger",
          });
          throw error;
        },
      });

      this.setLoading(false);
    },
    getUpdatedRequesStageAndQuoteStatus(quoteStatus) {
      const isNegotationStage =
        this.request.stage.id === REQUEST_STAGES.NEGOTIATION.id;

      if (quoteStatus === QUOTES_STATUS.SENT.id && !isNegotationStage)
        return { stage: REQUEST_STAGES.SENT, restQuotesStatus: null };

      if (quoteStatus === QUOTES_STATUS.CONFIRMED.id)
        return {
          stage: REQUEST_STAGES.WON,
          restQuotesStatus: QUOTES_STATUS.REJECTED,
        };

      const restRequestQuotesStatuses = this.request.items
        .filter((item) => item.id !== this.itinerary.data.id)
        .map((item) => item.status.id);

      const everyQuoteIsRejected = [
        ...restRequestQuotesStatuses,
        quoteStatus,
      ].every((status) => status === QUOTES_STATUS.REJECTED.id);

      if (everyQuoteIsRejected)
        return { stage: REQUEST_STAGES.LOST, restQuotesStatus: null };

      const everyQuoteIsInpreparation = [
        ...restRequestQuotesStatuses,
        quoteStatus,
      ].every((status) => status === QUOTES_STATUS.IN_PREPARATION.id);

      if (everyQuoteIsInpreparation)
        return { stage: REQUEST_STAGES.IN_PREPARATION, restQuotesStatus: null };

      const someQuoteIsInpreparation = [...restRequestQuotesStatuses].some(
        (status) => status === QUOTES_STATUS.IN_PREPARATION.id
      );

      if (
        someQuoteIsInpreparation &&
        quoteStatus === QUOTES_STATUS.REJECTED.id
      ) {
        return {
          stage: REQUEST_STAGES.NEGOTIATION,
          restQuotesStatus: null,
        };
      }

      return {
        stage: this.request.stage,
        restQuotesStatus: null,
      };
    },
  },
};
</script>

<style lang="scss" scope>
.itineraryTitle {
  cursor: pointer;
  overflow-wrap: anywhere;
}
.itinerary_code,
.itinerary_type {
  background-color: whitesmoke;
  width: fit-content;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  color: #444;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  display: inline-flex;
  margin-right: 0.5rem;
}
.itineraryLevelValues {
  align-items: center;
  margin-left: 2rem;
}
.itineraryShareValues .b-tooltip.is-primary .tooltip-content {
  background-color: #fff;
}
.itineraryShareValues .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #fff;
}
.b-tooltip.is-multiline.is-medium .tooltip-content {
  width: auto;
}

.status__select {
  width: 9rem;
}

.status__select * {
  font-size: 0.8rem;
  text-align: center;
}

.status__select option[disabled] {
  background-color: #f5f5f5;
}

@media screen and (max-width: 480px) {
  .itineraryShareValues {
    margin: 1rem 0;
  }
  .itineraryLevelValues {
    align-items: center;
    margin-left: 0rem;
    margin-top: 1rem;
    margin-bottom: 0rem;
    order: 2;
    width: 100%;
  }
  .cardItineraryContent {
    max-height: fit-content;
    max-width: fit-content;
    min-height: fit-content;
    min-width: fit-content;
    padding: 0.5rem;
    max-width: 5rem;
  }
}
</style>
